import UserProfile from "../features/User/components/UserProfile";

export default function UserProfilePage() {
  return <UserProfile />;
}
